<script>
import VSelect from 'vuetify/lib/components/VSelect';

export default defineComponent({
  extends: VSelect,

  props: {
    backgroundColor: {
      type: String,
      default: 'bnw100',
    },

    filled: {
      type: Boolean,
      default: true,
    },

    outlined: {
      type: Boolean,
      default: false,
    },

    rounded: {
      type: Boolean,
      default: true,
    },
  },
});
</script>
